// Bankrate-specific pipeline constants. Intentionally simpler than
// the main Lead pipeline so reporting stays clean.

export const BANKRATE_STATUSES = [
  'New',
  'Contacted',
  'Quoted',
  'Application Started',
  'Converted',
  'Dead',
];

export const LOAN_TYPES = ['Home Purchase', 'Home Refinance'];

export const PROPERTY_TYPES = [
  'Single Family Home',
  'Multi-Family Home',
  'Condominium',
  'Townhome',
];

export const PROPERTY_USES = ['Primary Home', 'Secondary Home', 'Rental Property'];

export const RATE_TYPES = ['Fixed', 'Adjustable'];

export const EMPLOYMENT_STATUSES = [
  'Employed',
  'Not Employed',
  'Self Employed',
  'Military',
  'Other',
];

export const CREDIT_PROFILES = [
  'Excellent > 740',
  'Good 700-739',
  'Fair 660-699',
  'Poor < 659',
];

// MUI Chip color per status
export const STATUS_COLORS = {
  New: 'info',
  Contacted: 'primary',
  Quoted: 'warning',
  'Application Started': 'secondary',
  Converted: 'success',
  Dead: 'default',
};

export function statusColor(status) {
  return STATUS_COLORS[status] || 'default';
}

export function fmtCurrency(n) {
  if (n === null || n === undefined || n === '') return '—';
  const num = Number(n);
  if (!Number.isFinite(num)) return String(n);
  return num.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  });
}
